import { ActionCall } from '@professocial/professocialTypes/types/commonTypes'
import { useSelector } from 'react-redux'
import { FacebookSettingsRootState } from '@professocial/professocialFacebookSettings/src/store/facebookSettingsRoot.reducer'
import { namedRequestData } from '@professocial/professocialFacebookSettings/src/store/common/common.selectors'
import { saveFacebookPageInformationInitiated, updateCoverImageInitiated, updateProfileImageInitiated } from '@professocial/professocialFacebookSettings/src/store/facebook/facebook.actions'
import { useEffect, useState } from 'react'
import * as React from 'react'
import { FacebookPage } from '@3m5/sm_publish-frontend-api'
import UserFacebookInfo from '@professocial/professocialFacebookSettings/src/screens/subScreens/UserFacebookInfo'
import UserFacebookImpressum from '@professocial/professocialFacebookSettings/src/screens/subScreens/UserFacebookImpressum'
import UserFacebookProfile from '@professocial/professocialFacebookSettings/src/screens/subScreens/UserFacebookProfile'
import { Box, Typography, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'

interface IProps {
  config?: FacebookPage
  activeStep: number
  confirmed: boolean
  handleCompleted: () => void
  setLoader: (value: boolean) => void
}

const useStyles = makeStyles((theme: Theme) => ({
  callout: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: '#1A2027',
    border: 'solid 1px',
    borderRadius: '10px',
    backgroundColor: 'rgba(255, 249, 235, 0.6)',
    borderColor: '#FFDC48',
  },
}))

const ImportProfessocialFacebookSettings: React.FC<IProps> = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [imprintData, setImprintData] = useState<string | undefined>(undefined)
  const actionOnSaveFacebookPage: ActionCall | undefined = useSelector((state: FacebookSettingsRootState) => namedRequestData(state, saveFacebookPageInformationInitiated.type))
  const actionOnUpdateProfileImage: ActionCall | undefined = useSelector((state: FacebookSettingsRootState) => namedRequestData(state, updateProfileImageInitiated.type))
  const actionOnUpdateCoverImage: ActionCall | undefined = useSelector((state: FacebookSettingsRootState) => namedRequestData(state, updateCoverImageInitiated.type))

  useEffect(() => {
    if (actionOnSaveFacebookPage?.status === 'pending') {
      props.setLoader(true)
    }
    if (actionOnSaveFacebookPage?.status === 'failed') {
      props.setLoader(false)
    }
    if (actionOnSaveFacebookPage?.status === 'success') {
      props.handleCompleted()
      props.setLoader(false)
    }
  }, [actionOnSaveFacebookPage])

  useEffect(() => {
    if (actionOnUpdateProfileImage?.status === 'pending') {
      props.setLoader(true)
    }
    if (actionOnUpdateProfileImage?.status === 'failed') {
      props.setLoader(false)
    }
    if (actionOnUpdateProfileImage?.status === 'success') {
      props.handleCompleted()
      props.setLoader(false)
    }
  }, [actionOnUpdateProfileImage])

  useEffect(() => {
    if (actionOnUpdateCoverImage?.status === 'pending') {
      props.setLoader(true)
    }
    if (actionOnUpdateCoverImage?.status === 'failed') {
      props.setLoader(false)
    }
    if (actionOnUpdateCoverImage?.status === 'success') {
      props.handleCompleted()
      props.setLoader(false)
    }
  }, [actionOnUpdateCoverImage])

  return (
    <>
      {props.activeStep === 1 && (
        <>
          <Box className={classes.callout}>
            <Typography variant='body2'>{t('coreWizard:textInfo')}</Typography>
          </Box>
          <Box sx={{ pb: 6 }}>
            <UserFacebookInfo
              isWizard
              wizardConfirmed={!!(props.confirmed && imprintData)}
              config={props.config}
              imprintData={imprintData}
            />
          </Box>
          <Box>
            <UserFacebookImpressum
              isWizard
              wizardConfirmed={props.confirmed}
              config={props.config}
              sendToWizard={(data: string) => setImprintData(data)}
            />
          </Box>
        </>
      )}
      {props.activeStep === 2 && (
        <Box>
          <Box className={classes.callout}>
            <Typography variant='body2'>{t('coreWizard:textProfile')}</Typography>
          </Box>
          <UserFacebookProfile isWizard wizardConfirmed={props.confirmed} onSetCompleted={props.handleCompleted} config={props.config} />
        </Box>
      )}
    </>
  )
}

export default ImportProfessocialFacebookSettings
